import { BasicScenario, Feature, FeatureCriteria, FeatureWrapper } from '@wizeoo/akm-message-lib';
import { Model } from '../../../model/model';
import { ExternalAPI } from '../../../model/external-api';
import { ViewData } from '../../../model/view.data';
import { FeatureVO } from '../../../vo/core/feature.vo';
import { WizCommand } from '@wizeoo/akm-component-lib';
import { WIZ_COMMAND_METHOD} from '@wizeoo/akm-core-lib';

/**
 * Appels feature (Find)
 */
export class FeatureCmd extends WizCommand<FeatureWrapper> {
  
  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  }
  
  /** retourne le wrapper pré-alimenté */
  public FeatureWrapper(): FeatureWrapper {
    const wrapper: FeatureWrapper = new FeatureWrapper();
    wrapper.criteria = new FeatureCriteria();
    wrapper.criteria.manageDeprecated = true;
    wrapper.criteria.manageDeleted = true;
    wrapper.scenario = new BasicScenario();
    wrapper.scenario.languageCode = this.model.localeEngine.getLocale();
    return wrapper;
  }


  /** chargement de toutes les features dynamiques pour LE domaine */
  public findForDomains(): FeatureCmd {
    const wrapper: FeatureWrapper = this.FeatureWrapper();
    wrapper.criteria.domainList = this.model.connectedUser.allDomains.map(d => d.code);
    wrapper.criteria.businessUnitCode = null;
    wrapper.method = WIZ_COMMAND_METHOD.FIND;
    this.configureRemote(ExternalAPI.FEATURE_API, wrapper);
    return this;
  }


  /** chargement de toutes les features dynamiques pour LE domaine */
  public find(): FeatureCmd {
    const wrapper: FeatureWrapper = this.FeatureWrapper();
    wrapper.criteria.domain = this.model.domainCode;
    wrapper.method = WIZ_COMMAND_METHOD.FIND;
    this.configureRemote(ExternalAPI.FEATURE_API, wrapper);
    return this;
  }

  /** chargement de toutes les features techniques */
  public findWildCardDomain(): FeatureCmd {
    const wrapper: FeatureWrapper = this.FeatureWrapper();
    wrapper.criteria.domain = ViewData.wildcardDomain;
    wrapper.criteria.businessUnitCode = ViewData.wildcardDomain;
    wrapper.method = WIZ_COMMAND_METHOD.FIND;
    this.configureRemote(ExternalAPI.FEATURE_API, wrapper);
    return this;
  }

  /**
   * retour de service
   * gestion de retour selon la méthode d'appelle
   */
  public wizResult(): void {
    super.wizResult();
    const wrapper: FeatureWrapper = this.result;
    // console.log('feature cmd wizResult', this.result);
    if (!!wrapper?.entities) {
    // convertion de la liste de retour en liste de FeatureVO
    const features: FeatureVO[] = wrapper.entities.map((element: Feature) => new FeatureVO(this.model, element));
    this.model.featureEngine.feedMap(features);
    } else {
      // console.log('feature cmd no result', this);
    }

  }
}
